var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Row',{staticClass:"ivu-mt",attrs:{"gutter":24}},[_c('Col',{staticClass:"ivu-mb",attrs:{"xl":10,"lg":8,"md":8,"sm":12,"xs":24}},[_c('notice')],1),_vm._v(" "),_c('Col',{staticClass:"ivu-mb",attrs:{"xl":6,"lg":8,"md":8,"sm":12,"xs":24}},[_c('shortcut')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }